import { Field, Form as FormikForm, Formik, ErrorMessage } from 'formik';
import Form from 'react-bootstrap/Form';
import React, { useEffect, useState, useCallback } from 'react';
import { Button, Col, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap';
import { RiDeleteBin6Line } from 'react-icons/ri';
import Pagination from 'react-js-pagination';
import { shallowEqual, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import API from '../../../../shared/AdminAxios';
import { showErrorMessage } from '../../../../shared/handle_error';
import closeIcon from '../../../../assets/images/close.svg';
import './productImage.css';

// Debounce function outside component to prevent recreation
const debounce = (func, delay = 300) => {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

const renderTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Delete Discounted Product
  </Tooltip>
);

export default function ProductImage() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [productImage, setProductImage] = useState([]);
  const [callPageNo, setCallPageNo] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [search, setSearch] = useState('');
  const [productData, setProductData] = useState(null);
  const [apiErrorMessage, setApiErrorMessage] = useState(null);
  const [inputValue, setInputValue] = useState('');

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((searchValue) => {
      setSearch(searchValue);
    }, 500),
    []
  );

  // Handle input change
  const handleInputChange = (e) => {
    const { value } = e.target;
    setInputValue(value);
    debouncedSearch(value);
  };

  // Clear search
  const clearSearch = () => {
    setInputValue('');
    setSearch('');
  };

  const handleClose = () => {
    setShow(false);
    setProductData(null);
    setApiErrorMessage(null);
    setInputValue('');
    setSearch('');
  };
  
  const handleShow = () => setShow(true);

  const productImageSchema = Yup.object().shape({
    productCode: Yup.string().required('Product Code is required'),
  });

  const handleSearch = (value) => {
    setSearch(value);
    setActivePage(1);
    getDiscountedProduct(1);
  };


  const handleSubmit = async (values, { setSubmitting }) => {
    if (productData) {
      // save api hit
      API({
        method: 'POST',
        url: `/api/adm/discounted-product`,
        data: productData,
      })
        .then((res) => {
          Swal.fire({
            icon: 'success',
            text: 'Product added to discounted list successfully',
          });
          handleClose();
          getDiscountedProduct();
        })
        .catch((err) => {
          showErrorMessage(err);
        });
    } else {
      setLoading(true);
      API({
        method: 'GET',
        url: `/api/adm/product/${values.productCode}`,
      })
        .then((res) => {
          if (res?.data?.data) {
            setProductData(res.data.data);
          }
        })
        .catch((err) => {
          if (err?.data?.message) {
            setApiErrorMessage(err.data.message);
          } else {
            setApiErrorMessage('Try again!');
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
    setSubmitting(false);
  };

  const getDiscountedProduct = (page = 1) => {
    setLoading(true);
    API({
      method: 'GET',
      url: `/api/adm/discounted-product?search_text=${search}&page=${page}`,
    })
      .then((res) => {
        setCount(res.data.count_product || 0);
        setProductImage(res.data.data || []);
        setCurrentPage(page);
      })
      .catch((err) => {
        showErrorMessage(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (code, e) => {
    e.preventDefault();
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success mx-3',
        cancelButton: 'btn btn-danger mx-3',
      },
      buttonsStyling: false,
    });
    
    swalWithBootstrapButtons.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        API({
          method: 'DELETE',
          url: `/api/adm/delete-discounted-product/${code}`,
        })
          .then((res) => {
            Swal.fire('Deleted!', 'The product has been removed from the discounted list.', 'success');
            getDiscountedProduct(activePage);
          })
          .catch((err) => {
            showErrorMessage(err);
          });
      }
    });
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    getDiscountedProduct(pageNumber);
  };

  useEffect(() => {
    getDiscountedProduct(activePage);
  }, [search, activePage]);

  // const newInitialValues = Object.assign(initialValues, {});
  return (
    <div className="content-wrapper p-1">
    <div className="row">
					<div className="col-md-12">
						<h3 className="mb-3">
							Manage Discounted Product &nbsp;
							<span>(Total : {count})</span>
						</h3>
					</div>
				</div>

      <section className="tableSection">
     
          <div className="col-md-12">
            <div className="cardBox" style={{ minHeight: '0', padding: '15px 15px 0px 15px' }}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="searchWrapper" style={{ width: '300px' }}>
                  <Form.Control
                    placeholder="Search by Product Code or Name"
                    type="text"
                    onChange={handleInputChange}
                    value={inputValue}
                    style={{ height: '38px' }}
                    className="form-control-sm"
                  />
                  {inputValue && (
                    <button
                      className="suffixIcon"
                      onClick={clearSearch}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        padding: '0 5px'
                      }}
                    >
                      <img src={closeIcon} alt="clear" style={{ width: '12px' }} />
                    </button>
                  )}
                
                  </div>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleShow}
                    style={{
                      backgroundColor: '#2C3192',
                      border: 'none',
                      height: '38px',
                      minWidth: '200px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }}
                  >
                    <i className="fas fa-plus"></i>
                    Add Discounted Product
                  </Button>
                </div>
            <Table responsive="md">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="text-white" style={{ textAlign: 'center', width: '33.33%' }}>
                    Product Code
                  </th>
                  <th className="text-white" style={{ textAlign: 'center', width: '33.33%' }}>
                    Product Name
                  </th>
                  <th className="text-white" style={{ textAlign: 'center', width: '33.33%' }}>
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
                      <Spinner animation="border" variant="primary" />
                    </td>
                  </tr>
                ) : productImage.length > 0 ? (
                  productImage.map((item, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: 'center' }}>{item.product_code}</td>
                      <td style={{ textAlign: 'center' }}>{item.product_name}</td>
                      <td>
                        <div style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                        }}>
                          <OverlayTrigger placement="left" overlay={renderTooltip}>
                            <span>
                              <RiDeleteBin6Line
                                style={{
                                  fontSize: '25px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '100%',
                                  height: '100%',
                                }}
                                className="text-danger"
                                onClick={(e) => handleDelete(item.product_code, e)}
                              />
                            </span>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
		
      </section>

      {count > 20 && (
        <Row>
          <Col md={12}>
            <div className="paginationOuter text-right">
              <Pagination
                activePage={activePage}
                itemsCountPerPage={20}
                totalItemsCount={count}
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
                prevPageText="Prev"
                nextPageText="Next"
                onChange={handlePageChange}
              />
            </div>
          </Col>
        </Row>
      )}

      {/* Modal for adding discounted product */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Discounted Product</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{ productCode: '' }}
          validationSchema={productImageSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, values, handleChange, handleBlur, errors, touched }) => (
            <FormikForm>
              <Modal.Body>
                <Form.Group controlId="productCode">
                  <Form.Label>Product Code</Form.Label>
                  <Field
                    type="text"
                    name="productCode"
                    as={Form.Control}
                    placeholder="Enter Product Code"
                    disabled={!!productData}
                    className={touched.productCode && errors.productCode ? 'is-invalid' : ''}
                  />
                  <ErrorMessage name="productCode" component="div" className="invalid-feedback" />
                  {apiErrorMessage && <div className="text-danger">{apiErrorMessage}</div>}
                  {productData && (
                    <div className="mt-2">
                      <p>Product Name: {productData.product_name}</p>
                    </div>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting || loading}
                  style={{ backgroundColor: '#2C3192', border: 'none' }}
                >
                  {loading ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  ) : productData ? (
                    'Add to Discounted List'
                  ) : (
                    'Check Product'
                  )}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>
    </div>
  )};
